<template>
  <v-row class="ma-0" >
    <v-col align="center" style="width: 490px;font-size: 13px">
      <v-card class="new-card pa-10 elevation-10" align="center">
        <div class="text-center mb-4">
          <img class="logo" src="@/assets/img/header_logo.png" alt="新学社">
        </div>
        <h2>新学社 テスト作成システム アカウント登録 認証ページ</h2>
        <div class="bold">
          採用教師用とともにお届けしている「教師用コンテンツダウンロード案内チラシ」に記載のパスワードを入力し、アカウント登録へお進みください。
        </div>
        <div class="password-area">
          <v-text-field
            v-model="localMaterialPasswords[0].value"
            outlined
            :error="localMaterialPasswords[0].error"
            @input="updateMaterialPasswords"
          ></v-text-field>
        </div>
        <div class="mb-6">
          ※案内チラシを紛失された場合や、パスワードがお分かりにならない場合は、弊社特約店までお問い合わせください。
        </div>
        <div class="warning-notice">
          <p class="mb-2">
            ※アカウント登録に関するお問合せはこちらまで
            <v-btn class="ml-2" small color="green" dark @click="openInquiry">問い合わせフォーム</v-btn>
          </p>
        </div>
        <div align="right">
          <v-btn class="mt-3" color="secondary" dark @click.stop="submit">認証</v-btn>
        </div>
      </v-card>
      <div class="back-area mt-6">
        <router-link class="back-link" to="/sign_in">← ログイン画面に戻る</router-link>
      </div>
    </v-col>
    <v-dialog v-model="authFailedDialog" max-width="560" persistent>
      <v-card class="pa-8" align="left">
        <div class="text-center mb-4">
          <img class="logo" src="@/assets/img/header_logo.png" alt="新学社">
        </div>
        <h2 class="text-center mb-6">パスワードが間違っています。</h2>
        <p class="dialog-message-red mb-6">
          採用教師用とともにお届けしている「教師用コンテンツダウンロード案内チラシ」に記載のパスワードを入力してください（英数字4文字）。<br>
          <br>
          案内チラシを紛失されたり、パスワードがお分かりにならない場合は、弊社特約店までお問い合わせください。
        </p>
        <div class="text-center">
          <v-btn color="secondary" dark @click="authFailedDialog = false">閉じる</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import config from '../../config'

export default {
  data() {
    return {
      localMaterialPasswords: [],
      hasError: false,
      authFailedDialog: false
    };
  },
  created() {
    JSON.parse(JSON.stringify(this.$store.state.school.materialPasswords)).map((materialPassword) => {
      this.localMaterialPasswords.push({
        value: materialPassword,
        error: false
      })
    })
  },
  methods: {
    updateMaterialPasswords() {
      this.$store.commit('school/setMaterialPasswords', {
        materialPasswords: this.localMaterialPasswords.map(materialPassword => materialPassword.value)
      })
    },
    validate() {
      // 日常教材の認証コードチェック
      this.localMaterialPasswords.forEach((materialPassword) => {
        if (materialPassword.value === '') {
          materialPassword.error = false
          return
        }
        const subjectGradeKeys = Object.keys(config.materialPasswords).filter(key => config.materialPasswords[key].includes(materialPassword.value))
        const today = new Date()
        const shingakuSubjectGradeKeys = []
        Object.keys(config.shingakuMaterialPasswords).forEach(year => {
          const yearData = config.shingakuMaterialPasswords[year]
          const startDate = new Date(yearData.start_date)
          const endDate = new Date(yearData.end_date)
          if (today < startDate || today > endDate) return

          Object.keys(yearData.codes).forEach(key => {
            if (yearData.codes[key].includes(materialPassword.value)) {
              shingakuSubjectGradeKeys.push(key)
            }
          })
        })
        if (shingakuSubjectGradeKeys.length > 0) {
          this.$store.commit('school/setIsShingaku', {
            isShingaku: true
          })
        }
        materialPassword.error = subjectGradeKeys.length === 0 && shingakuSubjectGradeKeys.length === 0
      })

      return this.localMaterialPasswords.some(materialPassword => materialPassword.error)
    },
    submit() {
      // お試しアカウント
      if (this.localMaterialPasswords.some(materialPassword => materialPassword.value === config.otameshiMaterialPassword)) {
        this.$store.commit('school/setIsOtameshiFlow', { isOtameshiFlow: true })
        this.$router.push('/enrollment/new')
        return
      }

      // 通常の認証フロー
      this.$store.commit('school/setIsOtameshiFlow', { isOtameshiFlow: false })

      this.hasError = this.validate()
      if (this.hasError) {
        this.authFailedDialog = true
        return
      }

      const nichijoSubjectGradeKeys = this.localMaterialPasswords.map(materialPassword => {
        return Object.keys(config.materialPasswords).filter(key => config.materialPasswords[key].includes(materialPassword.value))
      }).flat()

      const shingakuSubjectGradeKeys = {}
      this.localMaterialPasswords.forEach(materialPassword => {
        const today = new Date()
        const year = Object.keys(config.shingakuMaterialPasswords).find(year => {
          const yearData = config.shingakuMaterialPasswords[year]
          const startDate = new Date(yearData.start_date)
          const endDate = new Date(yearData.end_date)
          if (today < startDate || today > endDate) return false
          return Object.values(yearData.codes).flat().includes(materialPassword.value)
        })
        if (!year) return

        if (!shingakuSubjectGradeKeys[year]) {
          shingakuSubjectGradeKeys[year] = []
        }

        const keys = Object.keys(config.shingakuMaterialPasswords[year].codes).filter(key =>
          config.shingakuMaterialPasswords[year].codes[key].includes(materialPassword.value)
        )

        shingakuSubjectGradeKeys[year].push(...keys)
      })

      this.$store.commit('school/setNichijoSubjectGradeKeys', {
        nichijoSubjectGradeKeys: nichijoSubjectGradeKeys
      })

      this.$store.commit('school/setShingakuSubjectGradeKeys', {
        shingakuSubjectGradeKeys: shingakuSubjectGradeKeys
      })


      // shingakuSubjectGradeKeysのすべての値を配列として取得
      const allShingakuKeys = Object.values(shingakuSubjectGradeKeys).flat()

      // 重複を除去して結合
      this.$store.commit('school/setSubjectGradeKeys', {
        subjectGradeKeys: [...new Set([...nichijoSubjectGradeKeys, ...allShingakuKeys])],
      })

      this.$router.push('/enrollment/new')
    },
    openInquiry() {
      window.open('https://www.sing.co.jp/corp/contact/', '_blank')
    }
  }
};
</script>

<style lang="stylus" scoped>
h2
  color: #2d5aa3
  margin-bottom: 20px
  font-weight: bold
  font-size: 26px

.explanation
  width: 640px
  text-align: left

.password-area
  display: flex
  justify-content: center
  margin-top: 20px

  >>> .v-text-field
    max-width: 120px

.dialog-message-red
  font-size: 15px
  color: red

.warning-notice
  margin-top: 30px
  color: red
  font-weight: bold
  font-size: 16px
  text-align: center
  p
    margin-bottom: 8px

.back-area
  text-align: center

.back-link
  text-decoration: underline
  font-size: 13px
</style>
